import React, { useState, useEffect } from 'react';
import './social.css'; // Import CSS for the animations
import Footer from '../Footer';

const Social = () => {
  const [message, setMessage] = useState("Story is being uploaded...");

  useEffect(() => {
    const interval = setInterval(() => {
      setMessage((prevMessage) =>
        prevMessage === "Story is being uploaded..." ? "Stay Tuned, Coming Soon!!!" : "Story is being uploaded..."
      );
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Full viewport height
      }}
    >
      {/* Main content */}
      <div style={{ flex: 1, textAlign: 'center', marginTop: '50px' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '20px' }}>{message}</h2>
        <div className="upload-container">
          <div className="circle-loader"></div>
          <p className="upload-text">Uploading Story...</p>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Social;
